import {Box} from '@mui/material';
import PropTypes from 'prop-types';
import FormBuilder from './FormBuilder/FormBuilder';

const FormStructure = (props) => {
    const {
        schema,
        templateId,
        accessLevel,
        onSchemaChange,
        isFormArchived,
        isCommunication,
        formId,
        isWizardMode,
        componentToEditIndex,
        setComponentToEditIndex,
        onSchemaValidationChange,
        audience,
        parentAudienceType,
        recipientType,
        linkedToStudents,
        linkedToEmployees,
        triggerSourceAudience,
        scrollContainerRef,
        onScrollContainerScroll,
        title,
        previewMode,
        onPreviewModeChange,
        templateType,
    } = props;

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    // AD-2705: clip, not hidden, so the box is not a scroll container and the component sidebar
                    // can stick to the window as the page scrolls.
                    overflow: 'clip',
                }}
            >

                {schema && (
                    <Box
                        ref={scrollContainerRef}
                        onScroll={onScrollContainerScroll}
                        sx={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            // AD-2705: the page scrolls, not this box, so the sidebar can stick to the window and the page
                            // ends at the end of the form.
                            overflowX: 'clip',
                            // AD-2706: the builder fills the white panel below the tab bar, not a whole window, so a short form does not scroll.
                            minHeight: 'calc(100vh - 270px)'
                        }}
                    >
                        <FormBuilder
                            schema={schema}
                            schemaId={templateId}
                            onSchemaChange={onSchemaChange}
                            onSchemaValidationChange={onSchemaValidationChange}
                            isFormArchived={isFormArchived}
                            isCommunication={isCommunication}
                            accessLevel={accessLevel}
                            formId={formId}
                            isWizardMode={isWizardMode}
                            componentToEditIndex={componentToEditIndex}
                            setComponentToEditIndex={setComponentToEditIndex}
                            audience={audience}
                            parentAudienceType={parentAudienceType}
                            recipientType={recipientType}
                            linkedToStudents={linkedToStudents}
                            linkedToEmployees={linkedToEmployees}
                            triggerSourceAudience={triggerSourceAudience}
                            title={title}
                            previewMode={previewMode}
                            onPreviewModeChange={onPreviewModeChange}
                            formTemplateType={templateType}
                        />
                    </Box>
                )}
            </Box>
        </>
    );
};

FormStructure.propTypes = {
    title: PropTypes.string,
    previewMode: PropTypes.bool,
    onPreviewModeChange: PropTypes.func,
    templateType: PropTypes.string,
    accessLevel: PropTypes.number,
    onNameChange: PropTypes.func,
    schema: PropTypes.array,
    formRef: PropTypes.object,
    name: PropTypes.string,
    templates: PropTypes.array,
    handleTemplateChange: PropTypes.func,
    onSchemaChange: PropTypes.func,
    templateId: PropTypes.number,
    editMode: PropTypes.bool,
    isFormArchived: PropTypes.bool,
    expirationDate: PropTypes.string,
    remindInterval: PropTypes.number,
    onRemindIntervalChange: PropTypes.func,
    onExpirationDateChange: PropTypes.func,
    formId: PropTypes.number,
    formCategories: PropTypes.array,
    categories: PropTypes.array,
    onCategoriesChange: PropTypes.func,
    componentToEditIndex: PropTypes.number,
    setComponentToEditIndex: PropTypes.func,
    onSchemaValidationChange: PropTypes.func,
    isWizardMode: PropTypes.bool,
    audience: PropTypes.number,
    parentAudienceType: PropTypes.number,
    recipientType: PropTypes.string,
    linkedToStudents: PropTypes.bool,
    linkedToEmployees: PropTypes.bool,
    triggerSourceAudience: PropTypes.number,
    wizard: PropTypes.object,
    isCommunication: PropTypes.bool,
    scrollContainerRef: PropTypes.object,
    onScrollContainerScroll: PropTypes.func,
};

export default FormStructure;
